import * as React from "react";
import { useMemo } from "react";

import { useTypedSelector } from "../../../../../Common/UseTypedSelector";

import { mountModal } from "./Modals";

interface ModalManagerProps {
    children: React.ReactNode;
}

export function ModalManagerProvider(props: ModalManagerProps): JSX.Element {
    const modalInfo = useTypedSelector(state => state.modalState);
    const modal = useMemo(() => mountModal(modalInfo), [modalInfo?.isOpen]);

    return (
        <>
            {props.children}
            {modal}
        </>
    );
}
